package frontend.pages

import androidx.compose.runtime.*
import components.TButtonWide
import components.TTextInput
import frontend.components.RoundedForm
import frontend.lib.LocalString.*
import frontend.lib.classList
import kotlinx.coroutines.launch
import net.sergeych.crypto2.KDF
import net.sergeych.kilogin.client.Registration
import net.sergeych.ugdx.GuestAPI
import org.jetbrains.compose.web.css.whiteSpace
import org.jetbrains.compose.web.dom.*

@Composable
fun SignUpUI(toggle: () -> Unit) {
    val scope = rememberCoroutineScope()
    var login: String? by mutableStateOf(null)
    var inviteCode: String? by mutableStateOf(null)
    var password: String? by mutableStateOf(null)
    var passwordRepeat: String? by mutableStateOf(null)
    var isLoading: Boolean by mutableStateOf(false)
    var error: String? by mutableStateOf(null)

    suspend fun register(
        login: String?,
        password: String?,
        passwordRepeat: String?,
        inviteCode: String?
    ) {
        isLoading = true

        error = when {
            login == null -> LoginEmpty.t
            password == null -> PasswordEmpty.t
            password != passwordRepeat -> PasswordNotMatch.t
            inviteCode != null && !GuestAPI().isValidInviteCode(inviteCode) -> InvalidInviteCode.t
            !GuestAPI().isLoginNameAvailable(login) -> LoginUnavailable.t
            else -> {
                val result = try {
                    GuestAPI().register(
                        login, password, inviteCode,
                        passwordComplexity = KDF.Complexity.Interactive,
                        secretComplexity = KDF.Complexity.Interactive,
                    )
                }
                catch (e: Exception) {
                    // invalid invite code can fall here too:
                    e.toString()
                }
                when (result) {
                    Registration.Result.InvalidLogin -> LoginInvalid.t
                    //                is Registration.Result.LoginUnavailable -> LoginUnavailable.t
                                    is Registration.Result.OtherError -> result.code
                    is Registration.Result.Success -> null
                    else -> {
                        println("************** ${result::class.simpleName}  **************")
                        LoginUnavailable.t
                    }
                }
            }
        }

        isLoading = false
    }

    Div(attrs = {
        classList("fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-800")
    }) {

        Div(
            attrs = {
                classes("min-h-full", "flex", "flex-col", "justify-center", "py-12", "sm:px-6", "lg:px-8")
            }
        ) {
            Div(attrs = { classes("sm:mx-auto", "sm:w-full", "sm:max-w-md") }) { // 900/600
                H2(attrs = { classes("mt-6", "text-center", "text-3xl", "font-extrabold", "text-white") }) {
                    Text("Sign up")
                }
                P(attrs = { classes("mt-2", "text-center", "text-sm", "text-white") }) {
                    Text("Or ")
                    A("javascript:void(0);", attrs = {
                        classes("font-medium", "text-indigo-600", "hover:text-indigo-500")
                        onClick { toggle() }
                    }) {
                        Text("sign in")
                    }
                }
            }

            RoundedForm() {
                TTextInput("login", login ?: "") {
                    onInput { login = it }
                    label { Text("Login") }
                }
                TTextInput("password", password ?: "") {
                    password()
                    onInput { password = it }
                    label { Text("Password") }
                }
                TTextInput("passwordRepeat", passwordRepeat ?: "") {
                    password()
                    onInput { passwordRepeat = it }
                    label { Text("Repeat password") }
                }

                TTextInput("invite_code", inviteCode ?: "") {
                    onInput {
                        if (it == "") inviteCode = null
                        else inviteCode = it
                    }
                    label { Text("Invite code") }
                }

                if (error != null) P(attrs = {
                    classes("text-red-600")
                    style { whiteSpace("pre-line") }
                }) {
                    Text(error ?: "")
                }

                TButtonWide(attrs = {
                    onClick { scope.launch { register(login, password, passwordRepeat, inviteCode) } }
                    isLoading(isLoading)
                }) { Text("Register") }
            }
        }
    }
}